import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import api from '../services/api';
import './PdfViewer.css';

// Set PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function PdfViewer({ docId, filename }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfData, setPdfData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadPdf = async () => {
    setLoading(true);
    setError('');
    try {
      // Use the new getPdfBlob method
      const blob = await api.getPdfBlob(docId);
      setPdfData(blob);
    } catch (err) {
      console.error('Error loading PDF:', err);
      setError('Impossible de charger le PDF');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    loadPdf();
    return () => {
      setPdfData(null);
    };
  }, [docId]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const changePage = (offset) => {
    setPageNumber((prevPageNumber) => {
      const newPage = prevPageNumber + offset;
      if (newPage < 1 || newPage > numPages) return prevPageNumber;
      return newPage;
    });
  };

  if (loading) {
    return (
      <div className="pdf-viewer-loading">
        <div>Chargement du PDF...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="pdf-viewer-error">
        <div>{error}</div>
        <button onClick={loadPdf} className="pdf-retry-btn">Réessayer</button>
      </div>
    );
  }

  if (!pdfData) {
    return (
      <div className="pdf-viewer-error">
        <div>PDF non disponible</div>
      </div>
    );
  }

  return (
    <div className="pdf-viewer">
      <div className="pdf-controls">
        <button
          onClick={() => changePage(-1)}
          disabled={pageNumber <= 1}
          className="pdf-nav-btn"
        >
          &larr; Précédent
        </button>
        <span className="pdf-page-info">
          Page {pageNumber} / {numPages}
        </span>
        <button
          onClick={() => changePage(1)}
          disabled={pageNumber >= numPages}
          className="pdf-nav-btn"
        >
          Suivant &rarr;
        </button>
      </div>
      <div className="pdf-document">
        <Document file={pdfData} onLoadSuccess={onDocumentLoadSuccess}>
          <Page pageNumber={pageNumber} />
        </Document>
      </div>
    </div>
  );
}

export default PdfViewer;
